<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout wrap>
      <v-flex
        xs12
        md5
      >
        <v-card
          class="wallet-card"
        >
          <v-card-title>{{ $t("wallets.verifyWallet") }}</v-card-title>
          <verify-steps />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import VerifySteps from '@/views/Wallets/partial/VerifySteps.vue'

export default {
  name: "VerifyWallet",
  components: {
    VerifySteps
  },
};
</script>

<style lang="scss">

</style>
